import axios from "axios";
import { GetAxiosHeaders } from "../auth/GetAxiosHeaders";
import {
  CreateAccountRequest,
  CreateAccountResponse,
  InviteAccountRequest,
  InviteAccountResponse,
} from "../lib/ShiOneClient";

const baseUrl = `${import.meta.env.API_ENDPOINT}/api/aws/organizations`;

export async function postCreateAccount(
  request: CreateAccountRequest
): Promise<CreateAccountResponse> {
  const axiosHeaders = await GetAxiosHeaders();
  const response = await axios.post<CreateAccountResponse>(
    `${baseUrl}/create`,
    request,
    { headers: axiosHeaders }
  );
  return response.data;
}

export async function postInviteAccount(
  request: InviteAccountRequest
): Promise<InviteAccountResponse> {
  const axiosHeaders = await GetAxiosHeaders();
  const response = await axios.post<InviteAccountResponse>(
    `${baseUrl}/invite`,
    request,
    { headers: axiosHeaders }
  );
  return response.data;
}
